
(function($) { "use strict";


	// Marquee (Development names)
	$('.section-marquee').each(function(index) {
		gsap.to($(this).find(".marquee-element"), {
			x: '-16vw',
			scrollTrigger: {
				trigger: $(this),
				start: 'top bottom-=100px',
				end: "top -600px",
				scrub: true,
				// markers: true,
				id: "scrub"
			}
		});
	});


	// Heading underlines
	$('.contain__heading.has-underline').each(function(index) {
		gsap.to($(this).find(".heading-underline"), {
			x: 0,
			scrollTrigger: {
				trigger: $(this),
				start: "top bottom",
				end: "top 100px",
				scrub: true,
				// markers: true,
				id: "scrub"
			}
		});
	});

	// Section Underlines
	$('.contain__section.has-underline').each(function(index) {
		gsap.to($(this).find(".section-underline"), {
			x: 0,
			scrollTrigger: {
				trigger: $(this),
				start: "top bottom",
				end: "top 100px",
				scrub: true,
				id: "scrub"
			}
		});
	});

	// FUnction To Check Home Page
	function isHomePage() {
        return window.location.pathname === "/";
    }

	// Function For Scroll Event
    function scrollToElement(element) {
        if (element.length) {
            $('html, body').animate({
                scrollTop: element.offset().top
            }, 'slow');
        }
    }

	// Function To Get Query Params
    function getQueryParam(param) {
        let params = new URLSearchParams(window.location.search);
        return params.get(param);
    }

    // Handle click event
    $('body').on('click', '.scroll-to-section', function(event) {
        if (isHomePage()) {
            event.preventDefault();
            let element = $('#google-review');
            scrollToElement(element);
        } else {
			window.location.href('/?scrollTo=google-review');
        }
    });

    // Handle window load event
    $(window).on('load', function() {
        if (isHomePage()) {
            let scrollTo = getQueryParam('scrollTo');
            if (scrollTo) {
                let element = $('#' + scrollTo);
                scrollToElement(element);
            }
        }
    });

})(jQuery);








